// src/screens/NotFound.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-white text-[#4b3d91]">
      <h1 className="text-3xl font-bold mb-4">404 - Page Not Found</h1>
      <button
        onClick={() => navigate('/dashboard')}
        className="mt-2 px-5 py-2 bg-[#9481ce] text-white rounded-md shadow hover:bg-[#7d6ec0] transition-all"
      >
        Go to Dashboard
      </button>
    </div>
  );
}
